export enum AttendanceMessageDatasetType {
  SECTION_USER_ACTIVITY = "section-user-activity",
}

export type SectionUserActivityType = {
  sectionId: string;
  pageId: string;
  userId: string;
  active: "0" | "1";
  following: "0" | "1";
};

export type BaseAttendanceMessage = {
  type: "attendance-update";
  datasetType: AttendanceMessageDatasetType;
  targetRole: "all" | "student" | "staff";
  targetOrgId?: string;
  error?: unknown;
};

export type UserActivityMessage = BaseAttendanceMessage &
  SectionUserActivityType & {
    datasetType: AttendanceMessageDatasetType.SECTION_USER_ACTIVITY;
    removed?: "0" | "1";
  };

export type AttendanceMessageType = UserActivityMessage;
